// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"year-in-position-tenure-insights-chart_wrapper__5oysf","btn":"year-in-position-tenure-insights-chart_btn__-Bl9z"};